import fieldsNames from 'components/pages/Revenues/GeneratedRevenueForm/InvoiceForm/fieldsNames';
import { get } from 'lodash';
import { GeneratedInvoiceFormValues } from 'types/invoice.types';
import { cleanEmptyValues } from 'utils/helpers';

const formatRevenueForSubmit = (
  document: GeneratedInvoiceFormValues,
): GeneratedInvoiceFormValues => {
  const {
    revenueNumber,
    dueDate,
    type,
    invoiceDate,
    deliveryDate,
    deliveryPeriod,
    ...revenue
  } = document;
  return cleanEmptyValues(
    {
      ...revenue,
      items: revenue.items?.map((item) => ({
        ...item,
        assetId: item.assetId || undefined,
        description: item.description?.trim() || undefined,
      })),
      orderReference: revenue.orderReference?.trim() || null,
      comments: revenue.comments || undefined,
      communication: revenue.communication || undefined,
      recurringData: undefined,
      settings: {
        ...revenue.settings,
        includeCopyrightReminder:
          revenue.settings.includeCopyrightReminder ?? undefined,
        termsAndConditions: revenue.settings.termsAndConditions || undefined,
        logo: revenue.settings.logo || undefined,
        doesUnitPriceIncludeVAT: revenue.items?.every(
          (item) => item.doesUnitPriceIncludeVAT,
        ),
      },
      downPayment: get(revenue, fieldsNames.useDownpayment)
        ? revenue.downPayment || undefined // downpayment in this case could be 0 , we make sure its removed otherwise the backend will render it
        : undefined,
      user: {
        ...revenue.user,
        VATNumber: revenue.user.VATNumber || undefined,
        address: {
          ...revenue.user.address,
          street: revenue.user.address.street || undefined,
          city: revenue.user.address.city || undefined,
          zip: revenue.user.address.zip || undefined,
        },
      },
      type,
      dueDate,
      invoiceDate,
      deliveryDate: deliveryDate || null,
      deliveryPeriod: deliveryPeriod || null,
      revenueNumber,
    },
    ['VATRate', 'orderReference', 'paymentType'],
  );
};

export default formatRevenueForSubmit;
